import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CopilotSession {
  id: string;
  title: string;
  created_on: string;
  modified_on: string;
}

export interface CopilotMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  created_on: string;
  // Client-side send state (never comes from the API).
  failed?: boolean;
  sessionId?: string;
}

export interface QueuedSend {
  text: string;
  bubbleId: string;
}

@Injectable({
  providedIn: 'root',
})
export class CopilotService {
  private http = inject(HttpClient);
  private base = environment.baseApiUrl + 'copilot/';

  // The navbar "AI Copilot" button always starts a fresh session. The page
  // may already be open (same-URL navigation won't re-init it), so the
  // request is both emitted (open page picks it up live) and flagged
  // (freshly created page consumes it after loading the list).
  private newChatSignal = new Subject<void>();
  newChatRequested$ = this.newChatSignal.asObservable();
  private pendingNewChat = false;

  requestNewChat(): void {
    this.pendingNewChat = true;
    this.newChatSignal.next();
  }

  consumePendingNewChat(): boolean {
    const pending = this.pendingNewChat;
    this.pendingNewChat = false;
    return pending;
  }

  listSessions() {
    return this.http.get<any>(this.base + 'sessions');
  }

  createSession() {
    return this.http.post<any>(this.base + 'sessions', {});
  }

  deleteSession(id: string) {
    return this.http.delete<any>(this.base + `sessions/${id}`);
  }

  renameSession(id: string, title: string) {
    return this.http.patch<any>(this.base + `sessions/${id}`, { title });
  }

  getMessages(id: string) {
    return this.http.get<any>(this.base + `sessions/${id}/messages`);
  }

  sendMessage(id: string, message: string) {
    return this.http.post<any>(this.base + `sessions/${id}/chat`, { message });
  }
}
